<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-time-input [control]="control" [disabled]="disabled" #input [label]="label"
                         (focussed$)="onFocussed($event)" [(ngModel)]="value" *ngSwitchDefault></fui-edit-time-input>
    <fui-filter-time-input [disabled]="disabled" #input [(ngModel)]="value" (focussed$)="onFocussed($event)"
                           [label]="label" *ngSwitchCase="contextType.FILTER"></fui-filter-time-input>
    <fui-inline-time-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"></fui-inline-time-input>
    <fui-pill-time-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL"></fui-pill-time-input>
</ng-container>
